/**
 * Indicates which navigation section the user is currently in.
 */
export enum NavSectionEnum {

	None = 0,

	Home = 1,

	Quotes = 2,

	Shipment = 3,

	Tracking = 4,

	Reports = 5

}